import React, { useEffect, useRef } from 'react';

const PrivacyPolicy = () => {
  const contentRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
        }
      });
    }, observerOptions);

    if (contentRef.current) {
      observer.observe(contentRef.current);
    }

    return () => {
      if (contentRef.current) {
        observer.unobserve(contentRef.current);
      }
    };
  }, []);

  return (
    <section className="privacy-policy-section">
      <div className="privacy-policy-container">
        <h2 className="section-title">Privacy Policy</h2>
        <div className="content-paragraph" ref={contentRef}>
          <p><strong>Last Updated:</strong> {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
          
          <h3 className="subsection-title">Introduction</h3>
          <p>
            At VAT Calculator, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our VAT calculator service.
          </p>

          <h3 className="subsection-title">Information We Collect</h3>
          <p>
            Our VAT calculator operates entirely in your browser. We do not collect, store, or transmit any personal information or calculation data. All calculations are performed locally on your device, ensuring complete privacy and security.
          </p>
          <p>
            We may collect anonymous usage statistics through standard web analytics tools to improve our service, but this information cannot be used to identify you personally.
          </p>

          <h3 className="subsection-title">How We Use Information</h3>
          <p>
            Since we do not collect personal information, there is no personal data to use or share. Any anonymous analytics data is used solely to improve the functionality and user experience of our calculator.
          </p>

          <h3 className="subsection-title">Data Storage</h3>
          <p>
            Calculation history is stored locally in your browser's local storage. This data remains on your device and is never transmitted to our servers. You can clear this data at any time through your browser settings or by using the clear history feature in the calculator.
          </p>

          <h3 className="subsection-title">Cookies</h3>
          <p>
            We may use cookies to enhance your experience, but these are not used to track your personal information. You can disable cookies in your browser settings if you prefer.
          </p>

          <h3 className="subsection-title">Third-Party Services</h3>
          <p>
            Our website may use third-party analytics services to understand how visitors interact with our site. These services collect anonymous, aggregated data and cannot identify individual users.
          </p>

          <h3 className="subsection-title">Your Rights</h3>
          <p>
            Since we do not collect personal information, there is no personal data to access, modify, or delete. Your calculation data stored locally in your browser can be cleared at any time through your browser settings.
          </p>

          <h3 className="subsection-title">Changes to This Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date. We encourage you to review this policy periodically.
          </p>

          <h3 className="subsection-title">Contact Us</h3>
          <p>
            If you have any questions about this Privacy Policy, please contact us through our Contact Us page.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
